











import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import EditorWithFile from "@/components/EditorWithFile.vue";
import SelectEntity from "@/components/form/SelectEntity.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CField from "@/components/form/CField.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import Modal from "@/components/form/Modal.vue";
import { Registration as IRegistration } from "@/api-v2/course/models";
import CourseV2ListenerProgressItem from "@/components/courses/CourseV2/CourseV2ListenerProgressItem.vue";

@Component({
  components: {
    CourseV2ListenerProgressItem,
    Modal,
    CSingleSelect,
    CBlock,
    CField,
    CustomButton,
    EditorWithFile,
    SelectEntity
  }
})
export default class CourseV2ListenerProgress extends Vue {
  @Prop() registrations!: Array<IRegistration>;
}
